<template>
    <v-card>
        <v-form v-model="valid" ref="editProfileForm">
            <v-toolbar dark color="primary">
                <v-btn icon dark @click="cancel()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                <v-toolbar-title>Edit Profile</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-container fluid>
                    <v-layout>
                        <v-flex md4>
                            <v-text-field label="Name"
                                          v-model="profile.name"
                                          ref="profileName"
                                          :rules="serverValidation('name','Profile Name')"
                                          counter="100"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn outlined type="button" @click="cancel()" color="warning" :disabled="overlay">Cancel</v-btn>
                <v-btn outlined type="submit" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                <v-progress-circular
                        :width="3"
                        v-show="overlay"
                        color="red"
                        indeterminate="">
                </v-progress-circular>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>

    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        mixins:[validationMixin],
        name: 'EditProfile',
        data() {
            return {
                overlay: false,
                valid: false,
                profile: {},
                violations : [],
                profileId : null
            }
        },
        methods: {
            open : function(profileId) {
                this.reset;
                this.profileId = profileId;
                this.get();
            },
            reset() {
                this.profile = {};
                this.violations = [];
                this.overlay = false;
                this.valid = false;
                this.profileId = null;
            },
            get() {
                this.$root.$emit('showGlobalOverlay');
                api.profile.get(this.profileId).then((profile) => {
                    this.profile = profile;
                    this.$root.$emit('hideGlobalOverlay');
                    this.$nextTick(this.$refs.profileName.focus);
                });
            },
            save() {
                this.overlay = true;
                api.profile.patch(this.profile).then((profile) => {
                    this.reset();
                    this.$emit('saved',profile);
                    this.$root.$emit('globalMessage','Profile Saved');
                }, (error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.editProfileForm.validate();
                    }
                }).finally(() => this.overlay = false);
            },
            cancel() {
                this.$emit('cancelled');
            }
        }
    }

</script>